import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const initialState = {
  data: [],
  vehicleLoading: false,
  loadingMore: false,
  offsiteMoreDataAvailable: true,
  currentPage: 0,
};

const offsiteSlice = createSlice({
  name: "OFFSITE",
  initialState,
  reducers: {
    getOffsiteList(state, _) {
      state.vehicleLoading = true;
    },
    getOffsiteListSuccess(state, { payload }) {
      const { message, data = [] } = payload;
      state.vehicleLoading = false;
      state.data = data;
      if (data.length === 20) {
        state.offsiteMoreDataAvailable = true;
      } else {
        state.offsiteMoreDataAvailable = false;
      }
      state.currentPage = 1;
    },
    getOffsiteListError(state, { payload }) {
      console.log("inside error reducer");
      const { message = "Something went wrong." } = payload;
      toast.error(message);
      state.data = [];
      state.vehicleLoading = false;
    },
    loadMoreOffsite(state, _) {
      state.loadingMore = true;
    },
    loadMoreSuccessOffsite(state, { payload }) {
      const { message, data = [] } = payload;
      //   toast.success(message);
      state.loadingMore = false;
      if (data.length === 20) {
        state.offsiteMoreDataAvailable = true;
      } else {
        state.offsiteMoreDataAvailable = false;
      }
      state.data = [...state.data, ...data];
      state.currentPage += 1;
    },
    loadMoreErrorOffsite(state, { payload }) {
      console.log("inside error reducer");
      const { message = "Something went wrong." } = payload;
      //toast.error(message);
      // state.data = [];
      state.loadingMore = false;
    },
    addMoreNewOffsiteData(state, { payload }) {
      state.data = payload;
    },
    setOffsiteListPageNo(state, action) {
      state.pageNumber = action.payload;
    },
    setOffsiteVehicle(state, action) {
      state.vehicleId = action.payload;
    },

    setOffsiteFilterData(state, action) {
      state.filterData = action?.payload;
    },
  },
  extraReducers: {},
});

export const {
  getOffsiteList,
  getOffsiteListSuccess,
  getOffsiteListError,
  loadMoreOffsite,
  addMoreNewOffsiteData,
  setOffsiteListPageNo,
  setOffsiteVehicle,
  loadMoreSuccessOffsite,
  loadMoreErrorOffsite,
  setOffsiteFilterData,
} = offsiteSlice.actions;

// selectors
export const selectOffsiteData = (state) => state.offsite.data;
export const selectOffsiteVehicleLoading = (state) =>
  state.offsite.vehicleLoading;
export const selectOffsiteCurrentPage = (state) => state.offsite.currentPage;
export const selectOffsiteMoreDataAvailable = (state) =>
  state.offsite.offsiteMoreDataAvailable;
export const selectOffsiteVehicleNumber = (state) =>
  state.offsite.vehicleNumber;

export const getOffsitefilterData = (state) => state.offsite.filterData;

export default offsiteSlice.reducer;
